import { Injectable } from '@angular/core';
//import { CustomerClass } from '../models/customer.class';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Customer } from '../interfaces/customer.interface';
import { Router } from '@angular/router'; 
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  private customersUrl = environment.apiUrl + '/handlers/customersgetall.php';  // URL to web api
  private createcustomerUrl = environment.apiUrl + '/handlers/customercreate.php';  // URL to web api
  //private customersUrl = 'http://www.activenotify.com/handlers/customersgetall.php';  // URL to web api
  
  private updatecustomerUrl = environment.apiUrl + '/handlers/customerupdate.php';  // URL to web api
  /*
  private getcustomerUrl = 'http://www.activenotify.com/handlers/customerget.php';  // URL to web api
  private createcustomerUrl = 'http://www.activenotify.com/handlers/customercreate.php';  // URL to web api*/
  private deletecustomerUrl = environment.apiUrl + '/handlers/customerdelete.php';  // URL to web api
  

  public editcustomer: Customer = {} as Customer;
  customers: Customer[] = [];
  customer: Customer = {} as Customer;
  selectedCustomer: Customer = {} as Customer;

  constructor(private http: HttpClient, private router: Router) {

   }    

 async updateCustomer(customercode: string, customername: string, subsectorcode: string, origindate: string, expirydate: string, addressline1: string, addressline2: string, addresszip: string, phone: string, salesareacode: string, uploaded: string, id: number): Promise<void> {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
        try {
          const response$ = await firstValueFrom(this.http.post(this.updatecustomerUrl, JSON.stringify({customercode: customercode, customername: customername, subsectorcode: subsectorcode, origindate: origindate,expirydate:expirydate,addressline1:addressline1,addressline2:addressline2, addresszip:addresszip,phone:phone,salesareacode:salesareacode,uploaded: uploaded, distid: distid, id: id})));
           //return response$;
           return;
        }
        catch (error) {
          console.error(
            'Update Customer', error);
            throw error;
        };
    }
    

    async getCustomers(event?: Event): Promise<Customer[]> {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
        const data$ = this.http.post<Customer[]>(this.customersUrl,JSON.stringify({ distid: distid }))
        try {
          if (event) 
          {
            event.preventDefault();
          }
          this.customers = await firstValueFrom(data$);
          return this.customers;
        }
        catch (error) {
          console.error(
            'There was an error!', error);
            throw error;
        };  
    }
 
    async delete(id: number): Promise<void> {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
try 
    {
      const data$ = await this.http.post(this.deletecustomerUrl,JSON.stringify({id: id, distid: distid }))
      let response = await firstValueFrom(data$);
      return;
    }
    catch (error) 
    {
      console.error(
              'There was an error!', error);
              throw error;
    };  
   }  

   async create(customercode: string, customername: string, subsectorcode: string, origindate: string, expirydate: string, addressline1: string, addressline2: string, addresszip: string, phone: string, salesareacode: string, uploaded: string) : Promise<any> {
       let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
    let user = JSON.parse(cuser);
    let distid = user['distid'];

    const data$ = this.http.post(this.createcustomerUrl, JSON.stringify({customercode: customercode, customername: customername, subsectorcode: subsectorcode, origindate: origindate,expirydate:expirydate,addressline1:addressline1,addressline2:addressline2, addresszip:addresszip,phone:phone,salesareacode:salesareacode, uploaded:uploaded, distid: distid}))
         try {
           let x = await firstValueFrom(data$);
           return x;
         }
         catch (error) {
           console.error(
             'There was an error!', error);
             return;
         };  
}
/*
    getCustomer(id: number): Observable <Customer> {
        const url = `${this.getcustomerUrl}/${id}`;
        return this.http.get(url)
          .map(
              response=>response.json()
          );
    } */

}
